import { type ReactNode, useMemo, useRef } from 'react';
import { VideoControlContext } from '../VideoControlContext';

type VideoControlProviderProperties = {
  children: ReactNode;
};

const VideoControlProvider = ({ children }: VideoControlProviderProperties) => {
  const headerVideoRef = useRef<HTMLVideoElement>(null);
  const value = useMemo(() => ({ headerVideoRef }), [headerVideoRef]);

  return <VideoControlContext.Provider value={value}>{children}</VideoControlContext.Provider>;
};

export default VideoControlProvider;
